module.exports = __webpack_public_path__ + "img/content-btn2.a3c090ef.svg";